import { NavigationGuard } from 'vue-router';
import sl from '@/serviceLocator';

const adminGuard: NavigationGuard = () => {
  const store = sl.get('store');
  if (store.getters.isAdmin) {
    return true;
  }
  return '/403';
};

export default adminGuard;
